// GeburtsdatumPicker.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { deDE } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

export default function GeburtsdatumPicker() {
  const [value, setValue] = useState(null);

  useEffect(() => {
    const hiddenInput = document.querySelector('input[name="pd_geburtsdatum"]');
    if (hiddenInput && value) {
      hiddenInput.value = value.format('DD.MM.YYYY');
    }
  }, [value]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="de"
      localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box sx={{ width: '100%' }}>
        <DatePicker
          value={value}
          onChange={(newValue) => setValue(newValue)}
          format="DD.MM.YYYY"
          disableFuture // ✅ Only allow past dates
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'outlined',
              placeholder: 'TT.MM.JJJJ',
              required: true,
              className: 'pd-geburtsdatum',
              inputProps: {
                inputMode: 'none', // Prevent typing, allow click
              },
              onClick: (e) => e.target.focus(), // Ensure picker opens on click
            },
          }}
        />
        {/* Hidden input to send to PHP */}
        <input type="hidden" name="pd_geburtsdatum" />
      </Box>
    </LocalizationProvider>
  );
}